'use client';

import React, { memo, useMemo } from 'react';

interface AppLogoProps {
  src?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  showText?: boolean;
  textClassName?: string;
  variant?: 'default' | 'white' | 'dark';
}

const AppLogo = memo(function AppLogo({
  size = 64,
  className = '',
  onClick,
  variant = 'default',
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-90 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  const textColor =
    variant === 'white' ?'text-white'
      : variant === 'dark' ?'text-[#0F172A]' :'text-[#16A34A]';

  const fontSize = Math.max(14, size * 0.45);

  return (
    <div className={containerClassName} onClick={onClick}>
      <span
        className={`font-heading font-extrabold tracking-tight leading-none ${textColor}`}
        style={{ fontSize }}
      >
        MuyuRide
      </span>
    </div>
  );
});

export default AppLogo;
